import { RestUrl } from "../common/cyan.types";

export class ReleaseHistoryInternalUrl {
  public static getReleaseHistories: RestUrl = ["GET", "/releases"];
}
